import { createSelector } from 'reselect';
import { safelyParseData } from 'utils/safely-parse-data';

type TUserDataCookies = {
  customerId?: string | null;
  loyaltyCardNumber?: string | null;
};

type Cookies = {
  cookies: {
    cookies: {
      userData: string;
      customerId: string;
      _regionID: string;
    };
  };
};

export const getCookies = ({ cookies }: Cookies) => cookies.cookies;

export const selectUserCookies = createSelector(
  getCookies,
  (cookies): TUserDataCookies => {
    const userData = cookies?.userData?.replace(/\+/g, '');
    const parsedUserData = safelyParseData(userData);
    return {
      customerId: cookies?.customerId ?? null,
      loyaltyCardNumber: parsedUserData?.loyaltyCardNumber ?? null,
    };
  }
);

export const getCookiesString = createSelector(getCookies, cookies =>
  Object.entries(cookies)
    .map(cookie => cookie.join('='))
    .join('; ')
);

const cookiesKeysArray = ['access-token', 'projects'];
export const getRequestWhitelistCookiesString = createSelector(getCookies, cookies =>
  Object.entries(cookies)
    .filter(([key]) => cookiesKeysArray.includes(key))
    .map(cookie => cookie.join('='))
    .join('; ')
);
